import { useTranslation } from 'react-i18next'
import {
  Seo,
  Carousel,
  Hero,
} from 'ui'
import {
  useGetCarousels,
  useGetCarouselSerie,
  useGetSuggestionsSeries,
} from 'api/content'
import { Container } from './styles'
import { GROUP_ID } from 'utils/constants'
import { useSession } from 'hooks'
import { Div } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'


const Series = () => {

  const { t } = useTranslation()

  const { isLoggedIn } = useSession();
  const { isMobile } = useResponsive();

  const { data: carousels } = useGetCarousels(GROUP_ID.series)

  return (
    <Container>
      <Seo
        title={t('seoSeriesTitle')}
        description={t('seoSeriesDescription')}
      />

      <Hero />

      <Div transform={isMobile ? 'translateY(0)' : 'translateY(-135px)'}>
        {/*
          *   SUGGESTIONS
         **/}
        {isLoggedIn && (
          <Carousel
            title={t("continueWatching")}
            fetchFn={useGetSuggestionsSeries}
            hideUntilData
          />
        )}

        {/*
          *   REST OF THE CAROUSELS
         **/}
        {carousels.map(carousel => {
          if (!carousel.uuid) return null
          return (
            <Carousel
              key={carousel.uuid}
              uuid={carousel.uuid}
              title={carousel.title}
              fetchFn={useGetCarouselSerie}
            />
          )
        })}
      </Div>
    </Container>
  )
}

export default Series